import dictionaries from "./guest-name-dictionaries.json";
import { hasBadWord } from "./badWords";
import { api } from "@/services/api";

const candidateCache = new Map<string, string[]>();

export function guestNameCandidates(locale = "en"): string[] {
  if (candidateCache.has(locale)) return candidateCache.get(locale);
  const dictionary = dictionaries[locale] || dictionaries.en;
  const names = dictionary.prefixes.flatMap((prefix: string) =>
    dictionary.suffixes.map((suffix: string) => `${prefix}${suffix}`),
  );
  const candidates = Array.from(new Set<string>(names)).filter((name) => name.length >= 4 && name.length <= 15 && !hasBadWord(name));
  candidateCache.set(locale, candidates);
  return candidates;
}

/** Guest identities use English vocabulary regardless of interface language. */
export function generateGuestName(excluded: string[] = []): string {
  const candidates = guestNameCandidates().filter((name) => !excluded.includes(name));
  const pool = candidates.length ? candidates : guestNameCandidates();
  const random = typeof crypto !== "undefined" && crypto.getRandomValues
    ? crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296
    : Math.random();
  return pool[Math.floor(random * pool.length)];
}

/** Availability is a preference, never a reservation or a dependency of gameplay. */
export async function availableGuestName(excluded: string[] = []): Promise<string> {
  const attempted = [...excluded];
  let name = generateGuestName(attempted);
  for (let attempt = 0; attempt < 4; attempt++) {
    attempted.push(name);
    try {
      await api.post("/users/username-available", { username: name }, { timeout: 1200 });
      return name;
    } catch (error) {
      if (error?.response?.status !== 409) return name;
      name = generateGuestName(attempted);
    }
  }
  return name;
}
